import { mapStore } from "../store";

export function updateShowWorkbench(val: boolean) {
  mapStore.showWorkbench = val;
}
